import React from "react";
import { userHasAnyRole } from "../../../utils/SecurityUtils";
import { FACHADMIN, SYSTEMADMIN, ZUST_SBD } from "../../../consts/funktionaleRollen";
import { LageVerortung } from "../common/LageVerortung";
import "../../../styles/components/einleitstelleDaten.css";
import { getPegelOptionenEndpoint } from "../../../services/Messstellenservice";
import { useHttpSortById } from "../../../utils/usePreformattedHttp";

const id = "EinleitstelleDaten";

function EinleitstelleDaten({ formFactory, data, onChange, oberflaechenwasserkoerperLoading, teileinzugsgebietLoading, modus}) {
    const disabled = !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]);
    const [pegelOptions] = useHttpSortById(getPegelOptionenEndpoint);

    return (
        <div className="gridl einleitstelleDaten" style={{ gridTemplateColumns: "min-content" }}>
            <LageVerortung
                formFactory={formFactory}
                disabled={disabled}
                data={data.einleitstelle}
                onClick={(lage) => onChange("einleitstelle.lage", lage)}
                preName="einleitstelle."
                isButtonVisible={!disabled}
                style={{ marginLeft: 0 }}
                modus={modus}
            />
            {formFactory.renderInput(
                "einleitstelle.oberflaechenwasserkoerper.name",
                id + "-oberflaechenwasserkoerper",
                "Oberflächenwasserkörper",
                "text",
                true,
                {
                    loading: oberflaechenwasserkoerperLoading,
                }
            )}
            {formFactory.renderInput("einleitstelle.teileinzugsgebiet.name", id + "-teileinzugsgebiet", "Teileinzugsgebiet", "text", true, {
                loading: teileinzugsgebietLoading,
            })}
            {formFactory.renderAutocomplete(
                "einleitstelle.pegel",
                id + "-pegel",
                "Pegel",
                pegelOptions.data,
                "bezeichnung",
                "id",
                pegelOptions.loading,
                false,
                disabled
            )}
            {formFactory.renderNumberInput("einleitstelle.einleitungMnq", id + "-mq", "MNQ", disabled)}
            {formFactory.renderNumberInput("einleitstelle.einleitungMq", id + "-mq", "MQ", disabled)}
        </div>
    );
}

export default EinleitstelleDaten;
